import React from 'react';
import queryString from 'query-string';
import Head from 'next/head';
import { Flex } from '../Flex';
import { Image } from '../Image';
import { StyledSystemProps } from '../../types';
export type ArticleCoverPhotoValue = string;
type Props = StyledSystemProps & {
  src: ArticleCoverPhotoValue;
  alt: string;
};
export const ArticleCoverPhoto = ({
  src,
  alt,
  ...rest
}: Props) => {
  const {
    url,
    query
  } = queryString.parseUrl(src);
  const smallImageSrc = queryString.stringifyUrl({
    url,
    query: {
      // aspect ratio 4:3
      ...query,
      width: '328'
    }
  });
  const largeImageSrc = queryString.stringifyUrl({
    url,
    query: {
      // aspect ratio 4:3
      ...query,
      width: '640'
    }
  });
  return <>
      <Head data-sentry-element="Head" data-sentry-source-file="index.tsx">
        {/*
          > Experiment:
          > Since the hero images on Health Article is already visible
          > fetch it early before browser sees it on the HTML tree.
          > If we can load them early, this means image will be inserted immediately
          > and that *might* / *can* result to a better LCP score
           > Why only the small image?
          > Based on the field data (tested 28 days) at the time of writing this,
          > desktop has a good score compared with mobile
           > Field data: Desktop -> 2s - 2.3s
          > Field data: Mobile -> 2.1s - 2.5s
         */}
        <link rel="preload" href={smallImageSrc} as="image" />
      </Head>
      <Flex width={1} justifyContent={['stretch']} {...rest} data-sentry-element="Flex" data-sentry-source-file="index.tsx">
        <Image src={[smallImageSrc, largeImageSrc]} width={1} height="100%" borderRadius="inherit" alt={alt} style={{
        objectFit: 'cover'
      }} data-sentry-element="Image" data-sentry-source-file="index.tsx" />
      </Flex>
    </>;
};
export type ArticleCoverPhotoProps = Props;